/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aistudio1Inputs */

const en_aistudio1 = /** @type {(inputs: Aistudio1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Studio`)
};

const de_aistudio1 = /** @type {(inputs: Aistudio1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Studio`)
};

/**
* | output |
* | --- |
* | "AI Studio" |
*
* @param {Aistudio1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aistudio1 = /** @type {((inputs?: Aistudio1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aistudio1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aistudio1(inputs)
	return de_aistudio1(inputs)
});
export { aistudio1 as "aiStudio" }